/**
 * Decodes a recovery QR from an uploaded/captured image using jsqr, and
 * validates that it is a Jilu recovery code.
 */
import jsQR from 'jsqr';
import { RECOVERY_QR_PREFIX } from './recovery-artifact';

const decodeImageElement = (img: HTMLImageElement): string | null => {
  const canvas = document.createElement('canvas');
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  ctx.drawImage(img, 0, 0);
  const { data, width, height } = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const result = jsQR(data, width, height);
  return result?.data ?? null;
};

/** Decode any QR payload from an image file (returns the raw QR string). */
export const decodeQrFromFile = (file: File): Promise<string | null> =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const result = decodeImageElement(img);
      URL.revokeObjectURL(url);
      resolve(result);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    img.src = url;
  });

/** Returns the recovery key if `qr` is a valid Jilu recovery code, else null. */
export const extractRecoveryKeyFromQr = (qr: string | null): string | null => {
  if (!qr || !qr.startsWith(RECOVERY_QR_PREFIX)) return null;
  return qr.slice(RECOVERY_QR_PREFIX.length);
};
